export default "/dist/files/enerve-plein-stroke.f0a0ed8d652e1da9f6fa3b203363c56d.svg";